import { css } from '@emotion/react'
import { graphql, useStaticQuery } from 'gatsby'
import { ComponentPropsWithoutRef } from 'react'

import { MarkdownHeading } from '@/features/common'
import { DatoLink } from '@/features/links'
import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

type Props = ComponentPropsWithoutRef<'section'>

export const CtaBar = ({ ...props }: Props) => {
  const { data } = useStaticQuery<Queries.CtaBarQuery>(graphql`
    query CtaBar {
      data: datoCmsCtaBar {
        __typename
        id: originalId
        heading
        cta {
          ... on DatoCmsPageLink {
            ...PageLink
          }
          ... on DatoCmsLightboxLink {
            ...LightboxLink
          }
        }
      }
    }
  `)
  const styles = {
    section: css`
      background: ${colors.gray85};
      padding: var(--row-36) var(--margin);
      text-align: center;
    `,
    heading: css`
      font-size: var(--fs-36);
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.02em;
      color: ${colors.gray45};
      margin: 0.25em 0 0;
      em {
        color: ${colors.gray10};
        font-style: normal;
      }
      ${mq().s} {
        font-size: var(--fs-30);
      }
    `,
    cta: css`
      /* color: ${colors.greenDark}; */
      display: inline-block;
      font-size: var(--fs-21);
      margin-bottom: 0;
      margin-top: 0.75em;
      /* @media (hover: hover) {
        &:hover {
          color: ${colors.greenMid};
        }
      } */
    `,
  }
  return (
    <section
      css={styles.section}
      {...props}
    >
      <MarkdownHeading css={styles.heading}>
        {data?.heading || ''}
      </MarkdownHeading>
      <DatoLink
        css={styles.cta}
        data={data?.cta}
        showIcon
        styleVariant={'BUTTON'}
      />
    </section>
  )
}
